import './App.css'; // eslint-disable-next-line
import config from "./config.json"; // eslint-disable-next-line
import {useState,useEffect,useRef} from "react" // eslint-disable-next-line
import Map from './Components/Map'; // eslint-disable-next-line
import Loader from './Components/Loader'; // eslint-disable-next-line
import Widget from './Components/Widget'; // eslint-disable-next-line
import PendingWidget from './Components/PendingWidget'; // eslint-disable-next-line
import logo_TT from './logo_TT.png'; // eslint-disable-next-line
import logox_TT from './logox_TT.png' // eslint-disable-next-line
import TaghtialogoMain from './TaghtiaLogoMain.png';
import {loadModules} from 'esri-loader'
import makeDebugLog from './debugLog';
import InfoWidget from './Components/InfoWidget';
const FETCHING = true; // eslint-disable-next-line
const ACTIVE = false ; // eslint-disable-next-line
const DEBUG = true ; // eslint-disable-next-line
const PROD = false ; // eslint-disable-next-line
/*----------------------Mode---------------------------*/
const mode = DEBUG;
/*-------------------------------------------------*/
function App() {
  const pinLayer = useRef(null);
  const mapview = useRef(null);
  const controller = useRef(new AbortController());
  const signal = useRef(controller.current.signal);
  const basemapCarto = useRef(null);
  const basemapImagery = useRef(null);
  const poisLayer = useRef(null);
  const [loaded , setLoaded] = useState(false);
  const [status , setStatus] = useState(ACTIVE);
  const [pendingLocation , setPendingLocation] = useState(null);
  const [location , setLocation] = useState(null);
  const [locationCoords , setLocationCoords] = useState(null);
  const [triggetAbortCall , setTriggetAbortCall] = useState(false);
  const debugLogRef = useRef(makeDebugLog(mode)); // false parameter for prod mode and true or no parameter for debug mode
  const debugLog = debugLogRef.current;
  const iFrameDetection = useRef(window != window.parent)
  // use debugLog instead of console.log to avoid console.log in production mode
  function toggleTriggetAbortCall(){
    setTriggetAbortCall(triggetAbortCall=>!triggetAbortCall);
  }
  useEffect(()=>{
    //console.log(iFrameDetection);
    if(!iFrameDetection.current)  {
        console.log("Not opnened in iframe");
    }
    else {
        console.log("opened in iframe");
        debugLog(window.location);
        debugLog(window.parent)
    }
    loadModules(["esri/Basemap","esri/config","esri/layers/FeatureLayer"]).then(([Basemap,esriConfig,FeatureLayer])=>{
      esriConfig.apiKey = config.arcgisApiKey;
      esriConfig.portalUrl = config.portalUrl;
    
      basemapCarto.current = new Basemap({
        portalItem: { // autocasts as new PortalItem()
          id: config.mapIdCarto
        }
      })
      basemapImagery.current = new Basemap({
        portalItem: { // autocasts as new PortalItem()
          id: config.mapIdImagery
        }
      })
      poisLayer.current = new FeatureLayer({
        url:config.poisLayer,
        minScale : 6000
      })
      Promise.all([basemapImagery.current.loadAll() , basemapCarto.current.loadAll() , poisLayer.current.load()]).then(()=>{
        setLoaded(true);
      })
    })
  },[]);
  useEffect(()=>{
    const abortCallback = ()=>{
      controller.current = new AbortController();
      signal.current = controller.current.signal;
      toggleTriggetAbortCall();
    }
    signal.current.addEventListener("abort",abortCallback);
    return ()=>signal.current.removeEventListener("abort",abortCallback);
  },[triggetAbortCall])
  return (
    <div className="app">
    {!loaded?<Loader />:
    <>
      <header className="header">
        <img src={TaghtialogoMain} id="logo-taghtia"></img>
        <img src={logo_TT} id="logo-tt"></img>
      </header>
      <Map locationCoords={locationCoords} mapview={mapview} iFrameDetection={iFrameDetection} setPendingLocation={setPendingLocation} pinLayer={pinLayer} poisLayer={poisLayer}  basemapImagery={basemapImagery.current} basemapCarto={basemapCarto.current} location={location} setLocation={setLocation} setStatus={setStatus} signal={signal} controller={controller} />
      {pendingLocation?
      <PendingWidget setLocationCoords={setLocationCoords} mapview={mapview} debugLog={debugLog} setStatus={setStatus} controller={controller.current} pinLayer={pinLayer} pendingLocation={pendingLocation} setLocation={setLocation} setPendingLocation={setPendingLocation}/>
      :(!(pendingLocation||location))?
      <InfoWidget />
      :null}
      {status==FETCHING?
        <div className="fetching-modal">
          <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
      :null}
    </>
    }
    </div>
  );
}

export default App;
